const DISHES = [
  {
    id: 0,
    name: "Delicious Dishes",
    image: "asset/img/food.jpg",
    category: "meal",
    label: "hot",
    price: "199",
    description:
      "A unique combination of Indian chiken bergure and Italian pizza topped withg carignola olivesl. ripe vine cherry tomatoes.",
    // comments: [
    //   {
    //     id: "0",
    //     rating: 5,
    //     comment: "One of the best bergure I have ever eat.",
    //     author: "Shanto",
    //     date: "2019-10-",
    //   },
    //   {
    //     id: 1,
    //     rating: 4,
    //     comment:
    //       "Sends anyone to heaven, I wish I could get my mother in low to eat this.",
    //     author: "Karim",
    //     date: "2017-12",
    //   },
    //   {
    //     id: 2,
    //     rating: 3,
    //     comment: "Eat it, just eat it!",
    //     author: "Moinul",
    //     date: "2019-2",
    //   },
    //   {
    //     id: 3,
    //     rating: 4,
    //     comment: "Ultimate, Reaching for the stars!",
    //     author: "Rahat",
    //     date: "2017-6",
    //   },
    //   {
    //     id: 4,
    //     rating: 2,
    //     comment: "It's your birthday, we're gonna party!",
    //     author: "Rnoy",
    //     date: "2019-4",
    //   },
    // ],
  },
  // {
  //   id: 1,
  //   name: "Frech Fry",
  //   image: "asset/img/rachel-87711-2.jpg",
  //   category: "meal",
  //   label: "",
  //   price: "599",
  //   description:
  //     "Deep fried zucchini coated with midly spiced chikepa flour bettewr",
  // },
  //     comments: [
  //       {
  //         id: "0",
  //         rating: 5,
  //         comment: "One of the best bergure I have ever eat.",
  //         author: "Shanto",
  //         date: "2019-10-",
  //       },
  //       {
  //         id: 1,
  //         rating: 4,
  //         comment:
  //           "Sends anyone to heaven, I wish I could get my mother in low to eat this.",
  //         author: "Karim",
  //         date: "2017-12",
  //       },
  //       {
  //         id: 2,
  //         rating: 3,
  //         comment: "Eat it, just eat it!",
  //         author: "Moinul",
  //         date: "2019-2",
  //       },
  //       {
  //         id: 3,
  //         rating: 4,
  //         comment: "Ultimate, Reaching for the stars!",
  //         author: "Rahat",
  //         date: "2017-6",
  //       },
  //       {
  //         id: 4,
  //         rating: 2,
  //         comment: "It's your birthday, we're gonna party!",
  //         author: "Rnoy",
  //         date: "2019-4",
  //       },
  //     ],
  //   },
  {
    id: 2,
    name: "Chicken bar BQ",
    image: "asset/img/Easy-Chicken-Fry-Recipe.jpg",
    category: "meal",
    label: "",
    price: "599",
    description:
      "Deep fried zucchini coated with midly spiced chikepa flour bettewr",
    // comments: [
    //   {
    //     id: "0",
    //     rating: 5,
    //     comment: "One of the best bergure I have ever eat.",
    //     author: "Shanto",
    //     date: "2019-10-",
    //   },
    //   {
    //     id: 1,
    //     rating: 4,
    //     comment:
    //       "Sends anyone to heaven, I wish I could get my mother in low to eat this.",
    //     author: "Karim",
    //     date: "2017-12",
    //   },
    //   {
    //     id: 2,
    //     rating: 3,
    //     comment: "Eat it, just eat it!",
    //     author: "Moinul",
    //     date: "2019-2",
    //   },
    //   {
    //     id: 3,
    //     rating: 4,
    //     comment: "Ultimate, Reaching for the stars!",
    //     author: "Rahat",
    //     date: "2017-6",
    //   },
    //   {
    //     id: 4,
    //     rating: 2,
    //     comment: "It's your birthday, we're gonna party!",
    //     author: "Rnoy",
    //     date: "2019-4",
    //   },
    // ],
  },
  {
    id: 3,
    name: "Chicken Biriani",
    image: "asset/img/Biryani_Home.jpg",
    category: "meal",
    label: "",
    price: "599",
    description:
      "Deep fried zucchini coated with midly spiced chikepa flour bettewr",
    // comments: [
    //   {
    //     id: "0",
    //     rating: 5,
    //     comment: "One of the best bergure I have ever eat.",
    //     author: "Shanto",
    //     date: "2019-10-",
    //   },
    //   {
    //     id: 1,
    //     rating: 4,
    //     comment:
    //       "Sends anyone to heaven, I wish I could get my mother in low to eat this.",
    //     author: "Karim",
    //     date: "2017-12",
    //   },
    //   {
    //     id: 2,
    //     rating: 3,
    //     comment: "Eat it, just eat it!",
    //     author: "Moinul",
    //     date: "2019-2",
    //   },
    //   {
    //     id: 3,
    //     rating: 4,
    //     comment: "Ultimate, Reaching for the stars!",
    //     author: "Rahat",
    //     date: "2017-6",
    //   },
    //   {
    //     id: 4,
    //     rating: 2,
    //     comment: "It's your birthday, we're gonna party!",
    //     author: "Rnoy",
    //     date: "2019-4",
    //   },
    // ],
  },
  {
    id: 4,
    name: "Sandwich",
    image: "asset/img/vegetable-sandwich-recipe-500x375.jpg",
    category: "meal",
    label: "",
    price: "599",
    description:
      "Deep fried zucchini coated with midly spiced chikepa flour bettewr",
    // comments: [
    //   {
    //     id: "0",
    //     rating: 5,
    //     comment: "One of the best bergure I have ever eat.",
    //     author: "Shanto",
    //     date: "2019-10-",
    //   },
    //   {
    //     id: 1,
    //     rating: 4,
    //     comment:
    //       "Sends anyone to heaven, I wish I could get my mother in low to eat this.",
    //     author: "Karim",
    //     date: "2017-12",
    //   },
    //   {
    //     id: 2,
    //     rating: 3,
    //     comment: "Eat it, just eat it!",
    //     author: "Moinul",
    //     date: "2019-2",
    //   },
    //   {
    //     id: 3,
    //     rating: 4,
    //     comment: "Ultimate, Reaching for the stars!",
    //     author: "Rahat",
    //     date: "2017-6",
    //   },
    //   {
    //     id: 4,
    //     rating: 2,
    //     comment: "It's your birthday, we're gonna party!",
    //     author: "Rnoy",
    //     date: "2019-4",
    //   },
    // ],
  },
];
export default DISHES;
